/* eslint-disable simple-import-sort/imports */
import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../nativeComms";
import { trackEvent } from "./trackAnalytics";

//#!if ENV !== "production"
// import { loadInternalData } from "../testInBrowser/internalLoader";
//#!endif

const onSampleClick = filePath => {
  trackEvent("loadSample", "load", filePath);
  //#!if ENV !== "production"
  // Load the data internally..
// loadInternalData(filePath);
  // If we are in an app, we need to tell it that a file has been
  // created from this sample data...
// if (isNativeCommsInstalled()) {
// PubSub.publish(PubSubTopics.sendNativeMessage, {
// msg: nativeCommsBroadcastMessageTypes.FILE_CREATED,
// groupId: "examples",
// templateId: filePath
// });
// 
    // This is temporary until we move samples out of the JS
// PubSub.publish(PubSubTopics.sendNativeMessage, {
// msg: nativeCommsBroadcastMessageTypes.SAMPLE_LOADED
// });
// }
  //#!endif
};

export default onSampleClick;
